import { createRouter, createWebHistory } from "vue-router";
import IntroductionView from "../views/dashboard/introduce/index.vue";
import ProfileView from "../views/profiles/index.vue";

const routes = [
  {
    path: "/",
    name: "introduction-view",
    component: IntroductionView,
  },
  // Package giới thiệu
  {
    path: "/package",
    name: "package-view",

    component: () =>
      import(
        /* webpackChunkName: "package-view" */ "../views/dashboard/packages/index.vue"
      ),
  },
  // Features giới thiệu
  {
    path: "/features",
    name: "feature-view",

    component: () =>
      import(
        /* webpackChunkName: "feature-view" */ "../views/dashboard/features/index.vue"
      ),
  },
  // About giới thiệu
  {
    path: "/about",
    name: "about-view",

    component: () =>
      import(
        /* webpackChunkName: "about-view" */ "../views/dashboard/about/index.vue"
      ),
  },
  // Policy giới thiệu
  {
    path: "/policy",
    name: "policy-view",

    component: () =>
      import(
        /* webpackChunkName: "policy-view" */ "../views/dashboard/policy/index.vue"
      ),
  },
  // Term of service giới thiệu
  {
    path: "/term-of-service",
    name: "term-of-service-view",

    component: () =>
      import(
        /* webpackChunkName: "term-of-service-view" */ "../views/dashboard/term-of-service/index.vue"
      ),
  },
  // Profile
  {
    path: "/profile",
    name: "profile-view",
    component: ProfileView,
    children: [
      // màn hình Home
      {
        path: "feed",
        name: "feeds-view",

        component: () =>
          import(
            /* webpackChunkName: "feeds-view" */ "../views/profiles/feeds-page/index.vue"
          ),
      },
      // Màn edit profile
      {
        path: "edit-profile",
        name: "edit-profile-view",

        component: () =>
          import(
            /* webpackChunkName: "edit-profile-view" */ "../views/profiles/edit-profile/index.vue"
          ),
      },

      // Màn setting
      {
        path: "setting-profile",
        name: "setting-profile-view",

        component: () =>
          import(
            /* webpackChunkName: "setting-profile-view" */ "../views/profiles/settings/index.vue"
          ),
      },

      // Màn explore
      {
        path: "explore",
        name: "explore-view",

        component: () =>
          import(
            /* webpackChunkName: "explore-view" */ "../views/profiles/explore/index.vue"
          ),

        children: [
          // Màn tổng quan explore
          {
            path: "",
            name: "dashboard-explore-view",

            component: () =>
              import(
                /* webpackChunkName: "dashboard-explore-view" */ "../views/profiles/explore/dashboard/index.vue"
              ),
          },
          // Màn topic theo chủ đề
          {
            path: "topic",
            name: "topic-view",

            component: () =>
              import(
                /* webpackChunkName: "topic-view" */ "../views/profiles/explore/topic/index.vue"
              ),
          },
        ],
      },

      // Like and topic
      {
        path: "like-topic",
        name: "like-topic-view",

        component: () =>
          import(
            /* webpackChunkName: "like-topic-view" */ "../views/profiles/like-topic/index.vue"
          ),
      },
      // Màn xem chi tiết user Admin
      {
        path: "detail-admin",
        name: "detail-admin-view",

        component: () =>
          import(
            /* webpackChunkName: "detail-admin-view" */ "../views/profiles/detail-admin/index.vue"
          ),
      },
      // Tool update ảnh
      {
        path: "tool",
        name: "tool-view",

        component: () =>
          import(
            /* webpackChunkName: "tool-view" */ "../views/profiles/tool/index.vue"
          ),
      },
    ],
  },

  // Tao account
  {
    path: "/create-account",
    name: "create-account-view",

    component: () =>
      import(
        /* webpackChunkName: "create-account-view" */ "../views/create-account/index.vue"
      ),
  },
];
// Nhánh server - local
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
